<div class="row">
    <h2>Conversations</h2>
  </div>
<div class="listwrapper col gap-8 w100">
    <div class="w100 card col gap-8" *ngFor="let c of conversationStreams">
        <div class="row space-between w100">
            <div class="col gap-4">
                <div class="row gap-24 align-center">
                    <h4 class="strong">{{ c.name }}</h4>
                    <div class="row gap-8">
                        <rr-badge tone="success">{{ c.status }}</rr-badge>
                    </div>
                </div>
                <div class="row gap-8 tiny">
                    <span>Steps: {{ c.steps?.length || 0 }}</span>
                    <span *ngIf="c.conversations">|</span>
                    <span *ngIf="c.conversations">{{c.conversations}} conversations</span>
                    <span *ngIf="c.lastConversation">|</span>
                    <span *ngIf="c.lastConversation">Latest Conversation: 
                        {{ c.lastConversation | getLocaldateByTime }}
                    </span>
                </div>
            </div>
            <div class="row gap-8 align-center">
                <rr-btn
                    iconStart="eye"
                    size="Small"
                    type="Secondary"
                    (btnclick)="viewStreamConversation(c.id)"
                    >View</rr-btn
                >
            </div>
        </div>
    </div>
</div>

